import { useTranslations } from "next-intl";

import { Currencies } from "@/components/expense/fields/Currencies";
import { FormItem, FormLabel } from "@/components/ui/form";

interface ICurrencySelectorProps {
    isPending: boolean;
    value: string | undefined;
    onChange: (currency: string | undefined) => void;
}

export const CurrencySelector = ({ value, onChange, isPending }: ICurrencySelectorProps) => {
    const t = useTranslations("expense");

    return (
        <FormItem className="flex flex-col items-center justify-between md:flex-row">
            <FormLabel className="text-lg">{t("currency")} :</FormLabel>
            <div className="w-full md:w-1/2">
                <Currencies value={ value } onChange={ onChange } isPending={ isPending } />
            </div>
        </FormItem>
    );
};
